import { Lightning, Router } from '@lightningjs/sdk'

import { LiveScoresToggle } from '../../../components/LiveScoresToggle/LiveScoresToggle'
import PointerBackButton from '../../../components/NavigationPointers/PointerBackButton'
import { getColor, grey50, transparent } from '../../../constants/colors'
import { UniNeueHeavy } from '../../../constants/fonts'
import { LEFT_SAFE_ZONE_MARGIN } from '../../../constants/general'
import { Images } from '../../../constants/paths'
import { AppConfig } from '../../../services/appConfig'
import { getText } from '../../../utils/dictionary'
import { getAsset } from '../../../utils/image'
import { captureScreenData, NON_BFF_SEGMENT_SCREENS } from '../../../utils/segmentAnalytics'
import PageHandler from '../../handlers/pageHandler'

export default class LiveScores extends PageHandler {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: transparent,
      collision: true,
      flex: {
        direction: 'row',
        paddingLeft: LEFT_SAFE_ZONE_MARGIN,
      },
      LeftContainer: {
        w: 872,
        h: 1080,
        rect: true,
        color: transparent,
        Title: {
          y: 48,
          text: {
            text: getText('liveScores'),
            fontSize: 64,
            fontFace: UniNeueHeavy,
            textColor: getColor(grey50),
            lineHeight: 72,
          },
        },
        Icon: {
          x: 75,
          y: 358,
          texture: Lightning.Tools.getSvgTexture(getAsset(Images.SETTINGS_LIVE_SCORES), 472, 363),
        },
        PointerBackButton: {
          type: PointerBackButton,
          x: 1648,
          y: 48,
        },
      },
      RightContainer: {
        h: 1080,
        rect: true,
        color: transparent,
        flex: { direction: 'column', paddingTop: 200 },
        LiveScoresToggle: {
          type: LiveScoresToggle,
        },
      },
    }
  }

  get liveScoresToggle() {
    return this.tag('LiveScoresToggle') as LiveScoresToggle
  }

  get pageText(): string {
    return getText('liveScores')
  }

  get sectionText(): string {
    return ''
  }

  get pointerBackButton() {
    return this.tag('PointerBackButton') as PointerBackButton
  }

  _active() {
    void captureScreenData(NON_BFF_SEGMENT_SCREENS.Settings, NON_BFF_SEGMENT_SCREENS.LiveScores)

    const { isCursorVisible } = AppConfig.shared.appSettings
    this.pointerBackButton.visible = isCursorVisible
  }

  _getFocused() {
    return this.liveScoresToggle
  }

  _handleLeft() {
    Router.focusWidget('Menu')
  }

  _onCursorEnter() {
    const { isCursorVisible } = AppConfig.shared.appSettings
    this.pointerBackButton.visible = isCursorVisible
  }

  _onCursorLeave() {
    this.liveScoresToggle?._focus()
    this.pointerBackButton.visible = false
  }
}
